import React from 'react';

const Alert = ({
    children,
    variant = 'info',
    className = '',
    showIcon = true,
    ...props
}) => {
    const variants = {
        info: 'bg-blue-50 border-blue-200 text-blue-800',
        success: 'bg-green-50 border-green-200 text-green-800',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
        error: 'bg-red-50 border-red-200 text-red-800'
    };

    const icons = {
        info: 'ℹ️',
        success: '✅',
        warning: '⚠️',
        error: '❌'
    };

    const classes = `p-4 rounded-lg border ${variants[variant]} ${className}`;

    return (
        <div className={classes} {...props}>
            <div className="flex items-center">
                {showIcon && <span className="mr-2">{icons[variant]}</span>}
                <div>{children}</div>
            </div>
        </div>
    );
};

export default Alert;
